const getDefaultState = () => {
  return {
    contacts: [],
    contact: {},
    open_modal_delete_contact: false,
    open_modal_create_edit_contact: false,
    index_selected_contact: -1,
    open_modal_excel: false,
    upload_excel_details: null,
    form_title_contact: '',
    name_contact: '',
    email_contact: '',
    position_contact: '',
    seniority_contact: '',
    priority_contact: '',
    company_contact: '',
    country_contact: '',
    segmentation_contact: '',
    segmentation2_contact: '',
    tag_contact: '',
    contact_ass_to_round: []
  };
};

const state = getDefaultState();

const getters = {
  contact_ass_to_round (state) {
    return state.contact_ass_to_round;
  },
  name_contact (state) {
    return state.name_contact;
  },
  email_contact (state) {
    return state.email_contact;
  },
  position_contact (state) {
    return state.position_contact;
  },
  seniority_contact (state) {
    return state.seniority_contact;
  },
  priority_contact (state) {
    return state.priority_contact;
  },
  company_contact (state) {
    return state.company_contact;
  },
  country_contact (state) {
    return state.country_contact;
  },
  segmentation_contact (state) {
    return state.segmentation_contact;
  },
  segmentation2_contact (state) {
    return state.segmentation2_contact;
  },
  tag_contact (state) {
    return state.tag_contact;
  },
  form_title_contact (state) {
    return state.form_title_contact;
  },
  open_modal_create_edit_contact (state) {
    return state.open_modal_create_edit_contact;
  },
  open_modal_excel (state) {
    return state.open_modal_excel;
  },
  upload_excel_details (state) {
    return state.upload_excel_details;
  },
  contact (state) {
    return state.contact;
  },
  index_selected_contact (state) {
    return state.index_selected_contact;
  },
  open_modal_delete_contact (state) {
    return state.open_modal_delete_contact;
  },
  contacts (state) {
    return state.contacts;
  }
};

const mutations = {
  setContactAssToRound (state, payload) {
    state.contact_ass_to_round = payload;
  },
  setNameContact (state, payload) {
    state.name_contact = payload;
  },
  setEmailContact (state, payload) {
    state.email_contact = payload;
  },
  setPositionContact (state, payload) {
    state.position_contact = payload;
  },
  setSeniorityContact (state, payload) {
    state.seniority_contact = payload;
  },
  setPriorityContact (state, payload) {
    state.priority_contact = payload;
  },
  setCompanyContact (state, payload) {
    state.company_contact = payload;
  },
  setCountryContact (state, payload) {
    state.country_contact = payload;
  },
  setSegmentationContact (state, payload) {
    state.segmentation_contact = payload;
  },
  setSegmentation2Contact (state, payload) {
    state.segmentation2_contact = payload;
  },
  setTagContact (state, payload) {
    state.tag_contact = payload;
  },
  setFormTitleContact (state, payload) {
    state.form_title_contact = payload;
  },
  setOpenModalCreateEdit (state, payload) {
    state.open_modal_create_edit_contact = payload;
  },
  setOpenModalExcel (state, payload) {
    state.open_modal_excel = payload;
  },
  setUploadExcelDetail (state, payload) {
    state.upload_excel_details = payload;
  },
  setContact (state, payload) {
    state.contact = payload;
  },
  setIndexSelectedContact (state, payload) {
    state.index_selected_contact = payload;
  },
  setOpenModalDeleteContact (state, payload) {
    state.open_modal_delete_contact = payload;
  },
  filledContacts (state, payload) {
    state.contacts = payload;
  },
  addContact (state, payload) {
    if (payload.name && payload.email && payload.position && payload.company && payload.segmentation && payload.country && payload.seniority && payload.priority) {
      payload.is_filled = true;
    } else {
      payload.is_filled = false;
    }
    state.contacts.push(payload);
  },
  editContact (state, payload) {
    for (let i = 0; i < state.contacts.length; i++) {
      if (state.contacts[i].id === payload.id) {
        if (payload.name && payload.email && payload.position && payload.company && payload.segmentation && payload.segmentation2 && payload.country && payload.seniority && payload.priority) {
          state.contacts[i].is_filled = true;
        } else {
          state.contacts[i].is_filled = false;
        }
        state.contacts[i].name = payload.name;
        state.contacts[i].email = payload.email;
        state.contacts[i].position = payload.position;
        state.contacts[i].company = payload.company;
        state.contacts[i].segmentation = payload.segmentation;
        state.contacts[i].segmentation2 = payload.segmentation2;
        state.contacts[i].country = payload.country;
        state.contacts[i].seniority = payload.seniority;
        state.contacts[i].priority = payload.priority;
        state.contacts[i].tag = payload.tag;
        state.contacts[i].associated_round = payload.associated_round;
        state.contacts[i].updated_by_me = true;
      }
    }
  },
  destroyContact (state, index) {
    state.contacts.splice(index, 1);
  },
  setCleanAllContactsAssociatedToRound () {
    for (let i = 0; i < state.contacts.length; i++) {
      state.contacts[i].associated_round = false;
    }
  },
  setAssociatedContactToRound (state, payload) {
    for (let i = 0; i < state.contacts.length; i++) {
      for (let j = 0; j < payload.length; j++) {
        if (payload[i] === state.contacts[i].id) {
          state.contacts[i].associated_round = true;
        }
      }
    }
  },
  resetContacts (state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  setAssociatedContactToRound (context, payload) {
    context.commit('setAssociatedContactToRound', payload);
  },
  setCleanAllContactsAssociatedToRound (context) {
    context.commit('setCleanAllContactsAssociatedToRound');
  },
  setContactAssToRound (context, payload) {
    context.commit('setContactAssToRound', payload);
  },
  setNameContact (context, payload) {
    context.commit('setNameContact', payload);
  },
  setEmailContact (context, payload) {
    context.commit('setEmailContact', payload);
  },
  setPositionContact (context, payload) {
    context.commit('setPositionContact', payload);
  },
  setSeniorityContact (context, payload) {
    context.commit('setSeniorityContact', payload);
  },
  setPriorityContact (context, payload) {
    context.commit('setPriorityContact', payload);
  },
  setCompanyContact (context, payload) {
    context.commit('setCompanyContact', payload);
  },
  setCountryContact (context, payload) {
    context.commit('setCountryContact', payload);
  },
  setSegmentationContact (context, payload) {
    context.commit('setSegmentationContact', payload);
  },
  setSegmentation2Contact (context, payload) {
    context.commit('setSegmentation2Contact', payload);
  },
  setTagContact (context, payload) {
    context.commit('setTagContact', payload);
  },
  setFormTitleContact (context, payload) {
    context.commit('setFormTitleContact', payload);
  },
  setOpenModalCreateEdit (context, payload) {
    context.commit('setOpenModalCreateEdit', payload);
  },
  setOpenModalExcel (context, payload) {
    context.commit('setOpenModalExcel', payload);
  },
  setUploadExcelDetail (context, payload) {
    context.commit('setUploadExcelDetail', payload);
  },
  setContact (context, payload) {
    context.commit('setContact', payload);
  },
  setIndexSelectedContact (context, payload) {
    context.commit('setIndexSelectedContact', payload);
  },
  setOpenModalDeleteContact (context, payload) {
    context.commit('setOpenModalDeleteContact', payload);
  },
  callFilledContact (context, payload) {
    context.commit('filledContacts', payload);
  },
  callAddContact (context, payload) {
    context.commit('addContact', payload);
  },
  callEditContact (context, payload) {
    context.commit('editContact', payload);
  },
  callDestroyContact (context, index) {
    context.commit('destroyContact', index);
  }
};

export default {
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js